<template>
  <div>
    <ConfirmPopup> </ConfirmPopup>

    <slot :clicked="confirm"></slot>
  </div>
</template>

<script>
import ConfirmPopup from "primevue/confirmpopup";
export default {
  components: {
    ConfirmPopup,
  },
  props: {
    message: {
      type: String,
    },
    icon: {
      type: String,
    },
    acceptLabel: {
      type: String,
      default: "",
    },
    rejectLabel: {
      type: String,
      default: "",
    },
    acceptIcon: {
      type: String,
      default: "",
    },
    rejectIcon: {
      type: String,
      default: "",
    },
    acceptClass: {
      type: String,
      default: "",
    },
    rejectClass: {
      type: String,
      default: "",
    },
  },
  methods: {
    confirm(event) {
      this.$confirm.require({
        target: event.currentTarget,
        message: this.message,
        icon: this.icon,
        acceptLabel: this.acceptLabel,
        rejectLabel: this.rejectLabel,
        acceptIcon: this.acceptIcon,
        rejectIcon: this.rejectIcon,
        acceptClass: this.acceptClass,
        rejectClass: this.rejectClass,
        accept: () => {
          this.$emit("accept");
          //callback to execute when user confirms the action
        },
        reject: () => {
          this.$emit("reject");
          //callback to execute when user rejects the action
        },
      });
    },
  },
};
</script>
